import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  selectRequestState,
  selectLanguage,
  selectLanguagesApp
} from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

import LanguagesDrop from './LanguagesDrop';

const icons = {
  'ru-RU': 'RU',
  'en-US': 'EN'
};

class Languages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropDown: false
    };
  }

  render() {
    return (
      <li className={`dropdown ${this.state.showDropDown ? 'open' : ''}`}>
        <a
          href=""
          onClick={e => {
            e.preventDefault();
            this.setState({ showDropDown: !this.state.showDropDown });
          }}
        >
          {icons[this.props.language] || this.props.language}
        </a>
        {this.state.showDropDown ? (
          <LanguagesDrop
            {...this.props}
            closeDropdown={() => this.setState({ showDropDown: false })}
          />
        ) : null}
      </li>
    );
  }
}

Languages.propTypes = {
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired,
  language: PropTypes.string.isRequired,
  languagesApp: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state),
  language: selectLanguage(state),
  languagesApp: selectLanguagesApp(state)
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Languages);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Header/Languages/index.js